import * as Switch from "../../../src/Components/Switch/Switch.scss";
import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, lambda_type, unit_type, class_type, bool_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { logi } from "../../Utils.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { isNullOrWhiteSpace } from "../../fable_modules/fable-library.3.7.20/String.js";
import { DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import * as react from "react";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";


export class SwitchProps extends Record {
    constructor(Id, IsChecked, OnChange, IsDisabled) {
        super();
        this.Id = Id;
        this.IsChecked = IsChecked;
        this.OnChange = OnChange;
        this.IsDisabled = IsDisabled;
    }
}

export function SwitchProps$reflection() {
    return record_type("Components.Switch.SwitchProps", [], SwitchProps, () => [["Id", string_type], ["IsChecked", bool_type], ["OnChange", lambda_type(class_type("Browser.Types.Event", void 0, Event), unit_type)], ["IsDisabled", bool_type]]);
}

export function SwitchProps_get_GetDefault() {
    return new SwitchProps("", false, (_arg) => {
        logi("Switch - OnChange event fired, needs override.");
    }, false);
}

export function render(props) {
    let props_1;
    const children_2 = [(props_1 = toList(delay(() => append((!isNullOrWhiteSpace(props.Id)) ? singleton(new HTMLAttr(99, props.Id)) : ((empty())), delay(() => append(singleton(new HTMLAttr(65, "switch-base__input")), delay(() => append(singleton(new HTMLAttr(159, "checkbox")), delay(() => append(singleton(new HTMLAttr(62, props.IsChecked)), delay(() => append(singleton(new DOMAttr(9, props.OnChange)), delay(() => singleton(new HTMLAttr(79, props.IsDisabled)))))))))))))), react.createElement("input", keyValueList(props_1, 1))), react.createElement("span", {
        className: "switch-base__slider",
    })];
    return react.createElement("label", {
        className: "switch-base",
    }, ...children_2);
}

